// used for simplified document upload
import { DocumentGroupModel } from './document-group.model';
import type { DocumentModel } from './document.model';

export function getCurrentDocumentsFromGroup(documentGroups: DocumentGroupModel[]): DocumentModel[] {
  const documents: DocumentModel[] = [];

  documentGroups.forEach(documentGroup => DocumentGroupModel.allDocumentsFromGroup(documentGroup)?.forEach(document => {
    if (document.defaultDocument) {
      documents.push(document);
    }
  }));

  return documents;
}
